import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ErrorPageRouteState } from '@app/infrastructure/errors/models';

export const errorGuard: CanActivateFn = () => {
  const router = inject(Router);
  const routeState = router.currentNavigation()?.extras?.state as ErrorPageRouteState | undefined;

  return !!routeState && routeState.errorCode !== undefined ? true : router.createUrlTree(['/']);
};
